export default __webpack_public_path__ + "static/media/who-img.3b780da2.jpg";